import React from 'react'
import { Card, CardActions, CardContent, CardMedia, Button, Typography } from "@material-ui/core";
import useStyles from "./styles";
import { Link } from "react-router-dom";
import moment from "moment";
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import ThumbUpAltIcon from '@material-ui/icons/ThumbUpAlt';
import ThumbUpAltOutlined from "@material-ui/icons/ThumbUpAltOutlined";
import ModeCommentIcon from '@material-ui/icons/ModeComment';
import { useDispatch } from "react-redux";
import { likePost } from "./../../../redux/actions/post";

const Post = ({ post, setCurrentId, single }) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const user = JSON.parse(localStorage.getItem("profile"));

    const Likes = () => {
        if (post.likes.length > 0) {
            return post.likes.find(like => like === user?.user?._id) ?
                (
                    <><ThumbUpAltIcon fontSize="small" />&nbsp;{post.likes.length > 2 ? `You and ${post.likes.length - 1} others` : `${post.likes.length} like${post.likes.length > 1 ? 's' : ''}`}</>
                ) : (
                    <><ThumbUpAltOutlined fontSize="small" />&nbsp;{post.likes.length} {post.likes.length === 1 ? 'Like' : 'Likes'}</>
                );
        }

        return <><ThumbUpAltOutlined fontSize="small" />&nbsp;Like</>;
    };

    return (
        <Card className={`${classes.card} post`}>
            <CardMedia className={classes.media} image={post?.selectedFile} title={post.title} />
            <div className={classes.overlay}>
                <Typography variant="h6" component={Link} to={`/${post.creator}`}>
                    {post.name}
                </Typography>
                <Typography variant="body2">{moment(post.createdAt).fromNow()}</Typography>
            </div>

            {!single && (
                <div className={classes.overlay2}>
                    {user?.user?._id === post.creator && (
                        <Button style={{ color: "white" }} size="small" onClick={() => setCurrentId(post._id)}>
                            <MoreHorizIcon fontSize="default" />
                        </Button>
                    )}
                </div>
            )}

            <div className={classes.details}>
                <Typography variant="body2" color="textSecondary" component="h2">
                    {post.tags.map(tag => `#${tag} `)}
                </Typography>
            </div>

            <Typography className={classes.title} gutterBottom variant="h5" component="h2">
                <Link to={`/p/${post._id}`} style={{ color: "black" }}>{post.title}</Link>
            </Typography>
            <CardContent>

                {!single && (
                    <Typography variant="body2" color="textSecondary" component="p">
                        {post?.message?.substring(0, 90)}
                        {post?.message?.length > 90 && " ... "}
                        {post?.message?.length > 90 && (
                            <Link to={`/p/${post._id}`} className="link">Read More</Link>
                        )}
                    </Typography>
                )}

                {single && (
                    <Typography variant="body2" color="textSecondary" component="p">
                        {post.message}
                    </Typography>
                )}

            </CardContent>
            <CardActions className={classes.cardActions}>
                <Button size="small" color="primary" disabled={!user?.user?._id && true} onClick={() => dispatch(likePost(post._id))}>
                    <Likes />
                </Button>

                {!single && (
                    <Button size="small" color="primary" component={Link} to={`/p/${post._id}`}>
                        <ModeCommentIcon fontSize="small" />&nbsp;
                        {post.comments.length} Comment{post.comments.length === 1 ? '' : 's'}
                    </Button>
                )}

            </CardActions>

        </Card>
    )
}

export default Post;